"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.platforms = void 0;
exports.platforms = ["ios", "android", "windows", "macos", "web"];
//# sourceMappingURL=platforms.js.map